<template>
    <div class="p-4 text-white rounded-lg relative" :style="{ background: data.backgroundColor || '#667eea', border: data.hasRedLine ? '2px solid red' : `${data.borderWidth || 0}px solid ${data.borderColor || '#000000'}`, color: data.textColor || '#ffffff' }">
        <table width="100%" border="0" cellspacing="0" cellpadding="0">
            <tr>
                <td valign="middle">
                    <table border="0" cellspacing="0" cellpadding="0">
                        <tr>
                            <td style="padding-right: 15px;">
                                <div v-if="data.logo && data.logo.startsWith('http')" :style="{ width: '48px', height: '48px', borderRadius: '50%', overflow: 'hidden' }">
                                    <img :src="data.logo" :style="{ width: '100%', height: '100%', objectFit: 'cover' }" />
                                </div>
                                <div v-else :style="{ width: '48px', height: '48px', backgroundColor: '#cccccc', borderRadius: '50%', textAlign: 'center', lineHeight: '48px', fontSize: '24px' }">
                                    {{ data.logo || '🏢' }}
                                </div>
                            </td>
                            <td valign="middle">
                                <h1 class="text-xl font-bold" :style="{ color: data.textColor || '#ffffff' }" v-html="processRedMarkersForPreview(data.title || 'Bedrijfsnaam')"></h1>
                                <p class="text-sm" :style="{ color: data.textColor === '#ffffff' ? '#f9f9f9' : (data.textColor || '#ffffff') }" v-html="processRedMarkersForPreview(data.subtitle || 'Uw vertrouwde partner')"></p>
                            </td>
                        </tr>
                    </table>
                </td>
                <td v-if="data.showButton" align="right" valign="middle">
                    <a :href="data.buttonUrl || '#'" :style="{ backgroundColor: data.buttonColor || '#ffffff', color: data.buttonTextColor || '#000000', padding: '8px 16px', borderRadius: '4px', textDecoration: 'none', fontSize: '14px', fontWeight: '500' }">
                        {{ data.buttonText || 'Contact' }}
                    </a>
                </td>
            </tr>
        </table>
    </div>
</template>

<script>
import { processRedMarkersForPreview } from './redMarkHelpers';

export default {
    name: 'HeaderBlock',
    props: {
        data: {
            type: Object,
            default: () => ({})
        }
    },
    methods: {
        processRedMarkersForPreview,
        processRedMarkers(text) {
            if (!text) return '';
            return text.replace(/\[RED\](.*?)\[\/RED\]/g, '<span @if($show_clues)="" style="border: solid red 2px; padding: 2px; display: inline;" @endif="">$1</span>');
        },
        generateHTML() {
            const bgColor = this.data.backgroundColor || '#667eea';
            const textColor = this.data.textColor || '#ffffff';
            const borderColor = this.data.borderColor || '#000000';
            const borderWidth = this.data.borderWidth || 0;
            
            const logoHtml = this.data.logo && this.data.logo.startsWith('http')
                ? `<img src="${this.data.logo}" width="40" height="40" style="display: block; border: 0;" />`
                : `<table width="40" height="40" border="0" cellspacing="0" cellpadding="0" bgcolor="#cccccc" style="background-color: #cccccc;"><tr><td align="center" valign="middle" style="text-align: center; vertical-align: middle; font-size: 20px; line-height: 40px; font-family: Arial, sans-serif;">${this.data.logo || '🏢'}</td></tr></table>`;

            const processedTitle = this.processRedMarkers(this.data.title || 'Bedrijfsnaam');
            const processedSubtitle = this.processRedMarkers(this.data.subtitle || 'Uw vertrouwde partner');
            
            const styleAttr = this.data.hasRedLine
                ? `@if($show_clues) style="background-color: ${bgColor}; margin-bottom: 20px; border: solid red 2px;" @else style="background-color: ${bgColor}; margin-bottom: 20px; border: ${borderWidth}px solid ${borderColor};" @endif`
                : `style="background-color: ${bgColor}; margin-bottom: 20px; border: ${borderWidth}px solid ${borderColor};"`;
            
            const buttonHtml = this.data.showButton
                ? `<td align="right" valign="middle" style="text-align: right; vertical-align: middle;"><table border="0" cellspacing="0" cellpadding="0"><tr><td bgcolor="${this.data.buttonColor || '#ffffff'}" style="background-color: ${this.data.buttonColor || '#ffffff'}; padding: 8px 16px;"><a href="${this.data.buttonUrl || '#'}" style="color: ${this.data.buttonTextColor || '#000000'}; text-decoration: none; font-family: Arial, sans-serif; font-size: 14px; font-weight: 500; display: inline-block;">${this.data.buttonText || 'Contact'}</a></td></tr></table></td>`
                : '';
            
            return `
                <table width="100%" border="0" cellspacing="0" cellpadding="0" ${styleAttr} bgcolor="${bgColor}">
                    <tr>
                        <td style="padding: 20px;">
                            <table width="100%" border="0" cellspacing="0" cellpadding="0">
                                <tr>
                                    <td valign="middle" style="vertical-align: middle;">
                                        <table border="0" cellspacing="0" cellpadding="0">
                                            <tr>
                                                <td valign="middle" style="padding-right: 15px; vertical-align: middle;">
                                                    ${logoHtml}
                                                </td>
                                                <td valign="middle" style="vertical-align: middle;">
                                                    <table width="100%" border="0" cellspacing="0" cellpadding="0">
                                                        <tr>
                                                            <td style="font-family: Arial, sans-serif; margin: 0; color: ${textColor}; font-size: 24px; font-weight: bold; line-height: 28px;">
                                                                ${processedTitle}
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td style="font-family: Arial, sans-serif; margin: 5px 0 0 0; color: ${textColor === '#ffffff' ? '#f9f9f9' : textColor}; font-size: 14px; line-height: 18px;">
                                                                ${processedSubtitle}
                                                            </td>
                                                        </tr>
                                                    </table>
                                                </td>
                                            </tr>
                                        </table>
                                    </td>
                                    ${buttonHtml}
                                </tr>
                            </table>
                        </td>
                    </tr>
                </table>
            `;
        },
        getDefaultData() {
            return {
                logo: '',
                title: 'Bedrijfsnaam',
                subtitle: 'Uw vertrouwde partner',
                textColor: '#ffffff',
                backgroundColor: '#667eea',
                borderColor: '#000000',
                borderWidth: 0,
                showButton: false,
                buttonText: 'Contact',
                buttonUrl: '#',
                buttonColor: '#ffffff',
                buttonTextColor: '#000000',
                hasRedLine: false
            };
        }
    }
}
</script>